import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const GuestCheckout = () => {
  const navigate = useNavigate();

  const handleGuestCheckout = () => {
    localStorage.setItem('guestCheckout', 'true');
    navigate('/checkout-process');
  };

  return (
    <div className="mt-6 pt-6 border-t border-border">
      <div className="text-center">
        <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-2">
          Continue as Guest
        </h3>
        <p className="text-text-secondary text-sm mb-4">
          You can checkout without creating an account. You'll have the option to create one later.
        </p>
        <Button
          variant="outline"
          onClick={handleGuestCheckout}
          iconName="ShoppingCart"
          iconPosition="left"
          className="py-3"
        >
          Continue to Checkout
        </Button>
      </div>
    </div>
  );
};

export default GuestCheckout;